import styled from '@emotion/styled'

const sizeMap = { lg: '123%', sm: '76%' }
const Container = styled.div`
  border-radius: 5px;
  color: ${(props) => {
    const { textColor } = props
    return textColor
  }};
  background-color: ${(props) => {
    const { backgroundColor } = props
    return backgroundColor
  }};
  box-sizing: border-box;
  zoom: ${(props) => {
    const { size } = props
    return size && sizeMap[size] ? sizeMap[size] : '100%'
  }};
  display: flex;
  flex-wrap: nowrap;
`

export default Container
